import { forwardRef } from 'react';
import { StyledButton } from './styled';

const Button = forwardRef((props, ref) => (
  <StyledButton ref={ref} {...props} />
));

export default Button;
